<div class="empty-results-container">
  <div class="empty-results-text">
    <div class="empty-results-title bold">{{ header }}</div>
    <ng-content select="empty-results-text"></ng-content>
  </div>
</div>
